import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { ToastService } from '../../../base/services/toast.service';
import { SpinnerService } from '../../../base/spinner/spinner.service';
import {

  PrivacyPolicyClient,
  PrivacyPolicyDTO,
  CreatePrivacyPolicyDTO,
  UpdatePrivacyPolicyDTO,
  FilterDTO,
  SortDirection

} from '../../../base/models/models.swagger.generated';
import { ErrorType } from '../../../core/routing/error-types';
import { IPagedItems } from 'src/app/base/shared/table/paged-items.interface';
import { PagedQueryModel } from '../../../base/shared/table/paged-query-model';

@Injectable()
export class PrivacyPolicyService {
  constructor(
    private privacyPolicyClient: PrivacyPolicyClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) { }

  public getData(pagedQuery: PagedQueryModel): Observable<IPagedItems> {
    this.spinnerService.showSpinner = true;
    return this.privacyPolicyClient
      .getAllPrivacyPolicies()
      .pipe(
        tap(() => this.spinnerService.showSpinner = false),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError(
              'i18n.errors.server-error.title',
              'i18n.errors.server-error.message',
              null,
              ErrorType.serverError
            );
          }
          return throwError(() => error);
        }),
        map((data: PrivacyPolicyDTO[]) => ({
          items: data,
          totalNumberOfItems: data.length
        }))
      );
  }


  public updateRecord(data: UpdatePrivacyPolicyDTO): Observable<PrivacyPolicyDTO> {
    this.spinnerService.showSpinner = true;
    return this.privacyPolicyClient.updatePrivacyPolicy(data).pipe(
      tap(() => {
        this.spinnerService.showSpinner = false;
        this.toastService.showSuccess(
          'i18n.domain.privacy-policy.message.update-title',
          'i18n.domain.privacy-policy.message.update-success-message'
        );
      }),
      catchError((error: any) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null,
            ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }

  public addRecord(data: CreatePrivacyPolicyDTO): Observable<PrivacyPolicyDTO> {
    this.spinnerService.showSpinner = true;
    return this.privacyPolicyClient.createPrivacyPolicy(data).pipe(
      tap(() => {
        this.spinnerService.showSpinner = false;
        this.toastService.showSuccess(
          'i18n.domain.privacy-policy.message.add-title',
          'i18n.domain.privacy-policy.message.add-success-message'
        );
      }),
      catchError((error: any) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null,
            ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }


  public getLatest(): Observable<PrivacyPolicyDTO> {
    this.spinnerService.showSpinner = true;

    return this.privacyPolicyClient.getLatestPrivacyPolicy().pipe(
      tap(() => this.spinnerService.showSpinner = false),
      catchError((error: any) => {
        this.spinnerService.showSpinner = false;
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message',
            null,
            ErrorType.serverError
          );
        }
        return throwError(() => error);
      })
    );
  }

}
